/**
 * @generated SignedSource<<a7ede0fca024c99a9457c2c899fe7651>>
 * @relayHash ce260380c8e0539a0a84ff5ad8c169e3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce260380c8e0539a0a84ff5ad8c169e3

import { ConcreteRequest } from 'relay-runtime';
export type AsynchronousQuestionnaireUsage = "ACCEPTED" | "ALL" | "DECLINED";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useTreatmentPlanTemplatesByIcdCodeQuery$variables = {
  country: Country;
  diagnosisCode: string;
};
export type useTreatmentPlanTemplatesByIcdCodeQuery$data = {
  readonly treatmentPlanTemplatesByIcdCode: ReadonlyArray<{
    readonly amountOfDays: number | null;
    readonly asynchronousQuestionnaireUsage: AsynchronousQuestionnaireUsage | null;
    readonly id: string;
    readonly languages: ReadonlyArray<{
      readonly followUpInstructions: string | null;
      readonly language: Language;
      readonly recommendedTreatment: string | null;
      readonly synonym: string | null;
      readonly title: string;
    }>;
    readonly name: string;
  }>;
};
export type useTreatmentPlanTemplatesByIcdCodeQuery = {
  response: useTreatmentPlanTemplatesByIcdCodeQuery$data;
  variables: useTreatmentPlanTemplatesByIcdCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "country"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "diagnosisCode"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "country",
        "variableName": "country"
      },
      {
        "kind": "Variable",
        "name": "diagnosisCode",
        "variableName": "diagnosisCode"
      }
    ],
    "concreteType": "TreatmentPlanTemplate",
    "kind": "LinkedField",
    "name": "treatmentPlanTemplatesByIcdCode",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountOfDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asynchronousQuestionnaireUsage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TreatmentPlanTemplateLanguage",
        "kind": "LinkedField",
        "name": "languages",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "synonym",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendedTreatment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followUpInstructions",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTreatmentPlanTemplatesByIcdCodeQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useTreatmentPlanTemplatesByIcdCodeQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "ce260380c8e0539a0a84ff5ad8c169e3",
    "metadata": {},
    "name": "useTreatmentPlanTemplatesByIcdCodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e158f2ebe994c99f79317ece36cbd6ac";

export default node;
